import axios from "@/utils/request";
import Api from "../api";
import * as Request from "../request.type";
import * as ResponseData from "../response.type";

/**
 * 根据票号查询车票信息
 * @param params - 查询参数
 * @returns 车票详细信息
 */
export const getTicketByTicketNo = async (
  params: Request.GetTicketByTicketNoParams
) => {
  return await axios.get<ResponseData.TicketDetail[]>(
    Api.GET_TICKET_BY_TICKET_NO,
    {
      params,
    }
  );
};
